module.exports = {
    countDown(_this){
      if(_this.time>=0){
        setTimeout(()=>{
             _this.time=_this.time-=1
            _this.utils.countDown(_this)
        },1000)
      }else{
          _this.isTime = true
          _this.time = 60    
      } 
    },
    isAndroid(){if(/Android [4-9]/.test(navigator.appVersion)) {
           window.addEventListener("resize", function() {
            if(document.activeElement.tagName=="INPUT" || document.activeElement.tagName=="TEXTAREA") {
//                alert(navigator.appVersion)
//                 alert(document.activeElement)
                 document.activeElement.scrollIntoView(true);
             }
            })
        }
     }
}


// WEBPACK FOOTER //
// ./src/base/js/utils.js